// Site-wide content data for Wedding Video Essex Reviews

export const SITE = {
  name: "Wedding Video Essex Reviews",
  shortName: "WVE Reviews",
  domain: "weddingvideoessexreviews.co.uk",
  url: "https://weddingvideoessexreviews.co.uk",
  bookingUrl: "https://www.weddingvideo.co.uk/contact",
  hitchedUrl:
    "https://www.hitched.co.uk/wedding-videographers/wedding-video-essex-films-&-photos_272043.htm",
  tagline: "The most-reviewed wedding videographer and photographer in Essex.",
  email: "alex@weddingvideo.co.uk",
  phone: "+44 1277 280512",
  phoneDisplay: "01277 280 512",
  address: {
    street: "Unit 6 Hodgson Court, Hodgson Way",
    locality: "Wickford",
    region: "Essex",
    postalCode: "SS11 8XR",
    country: "GB",
  },
  serviceArea: "Essex, London, Kent, Suffolk",
  founded: 2015,
};

export const STATS = [
  { value: "1000+", label: "Happy couples" },
  { value: "389", label: "Five-star reviews" },
  { value: "12+", label: "Years of weddings" },
  { value: "8x", label: "Award winners" },
];

export const AWARDS = [
  {
    name: "Essex Wedding Awards 2026, Winner",
    img: "https://customer-assets.emergentagent.com/job_wve-wedding-showcase/artifacts/t490eo40_essex-wedding-awards-winner-logo-2026.png",
  },
  {
    name: "Hitched Wedding Awards 2026",
    img: "https://customer-assets.emergentagent.com/job_wve-wedding-showcase/artifacts/6c9sworo_badge-weddingawards_en_GB_edited.png",
  },
  {
    name: "Bridebook Platinum 2026",
    img: "https://image.bridebook.com/badge/platinum-2026-uk@v1.png",
  },
];

export const COUPLE_IMAGES = [
  {
    src: "https://customer-assets.emergentagent.com/job_wve-wedding-showcase/artifacts/4tj3d52l_Helen%20%26%20Daniel%2014-07-25%20%20009.jpg",
    alt: "Helen and Daniel, Essex wedding film",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_8d44df25-0f67-4d0d-b916-c24ae1fa8d16/artifacts/lgsxk5pq_Bonnie__Josh_SP_.jpg",
    alt: "Bonnie and Josh, Essex wedding videography",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_wve-wedding-showcase/artifacts/aiky4ekf_Paige__Richard_070724__625.jpg",
    alt: "Paige and Richard, wedding film Essex",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_8d44df25-0f67-4d0d-b916-c24ae1fa8d16/artifacts/3xdtp1cg_Preview-45.jpg",
    alt: "Essex cinematic wedding still",
  },
];

export const ALEX_PHOTO =
  "https://customer-assets.emergentagent.com/job_8d44df25-0f67-4d0d-b916-c24ae1fa8d16/artifacts/ifu7svtq_IMG_1066.jpeg";

export const FILM_THUMBS = [
  { id: "KTLcIqddWSE", thumb: "https://img.youtube.com/vi/KTLcIqddWSE/maxresdefault.jpg" },
  { id: "tSAyeoBfnOk", thumb: "https://img.youtube.com/vi/tSAyeoBfnOk/maxresdefault.jpg" },
  { id: "TSGJyA-meX8", thumb: "https://img.youtube.com/vi/TSGJyA-meX8/maxresdefault.jpg" },
  { id: "OynwPvMB2i0", thumb: "https://img.youtube.com/vi/OynwPvMB2i0/maxresdefault.jpg" },
  { id: "1DXk4bMe3WM", thumb: "https://img.youtube.com/vi/1DXk4bMe3WM/maxresdefault.jpg" },
  { id: "ylVnOyaa76E", thumb: "https://img.youtube.com/vi/ylVnOyaa76E/maxresdefault.jpg" },
];

export const PACKAGES = [
  {
    slug: "photo-video-collection",
    badge: "Complete package",
    name: "Photo & Video Collection",
    price: "£3,000",
    monthly: "£250/mo",
    highlights: [
      "Two videographers + one photographer",
      "Full day coverage, prep to first dance",
      "20–30 minute cinematic film",
      "Full-length ceremony, speeches & first dance films, delivered separately",
      "500+ professionally edited photos",
      "3–4 minute sneak peek within 72 hours",
    ],
  },
  {
    slug: "video-collection",
    badge: "Most popular",
    name: "The Wedding Video Collection",
    price: "£2,295",
    monthly: "£191/mo",
    highlights: [
      "Two videographers all day",
      "Full day coverage, prep to first dance",
      "20–30 minute cinematic film",
      "Full-length ceremony, speeches, cake cut & first dance films, delivered separately",
      "3–4 minute sneak peek within 72 hours",
      "No hidden charges. Ever.",
    ],
  },
  {
    slug: "photo-and-highlight",
    name: "Photo & Highlight Video",
    price: "£2,000",
    monthly: "£166/mo",
    highlights: [
      "One videographer + one photographer",
      "Up to 8 hours coverage",
      "10–15 minute highlight film",
      "300–500 professionally edited photos",
    ],
  },
  {
    slug: "photo-collection",
    name: "The Photo Collection",
    price: "£1,500",
    monthly: "£125/mo",
    highlights: [
      "One photographer",
      "Up to 8 hours coverage",
      "Online gallery with 500+ photos",
      "30–40 sneak peek photos within one week",
    ],
  },
];

export const PRICING_QUOTES = [
  {
    text: "Aside from our venue and the legal bits, hiring Wedding Video Essex was hands down the best money we spent for our special day.",
    name: "Robyn",
    source: "Guides for Brides",
    url: "https://guidesforbrides.co.uk/wedding-videographers-and-video/essex/wedding-video-essex/165670",
  },
  {
    text: "I would highly recommend Alex and his team, we feel it was worth every penny.",
    name: "Raymon",
    source: "Guides for Brides",
    url: "https://guidesforbrides.co.uk/wedding-videographers-and-video/essex/wedding-video-essex/165670",
  },
  {
    text: "Such amazing value for money and worth every penny. He is so professional and such a lovely guy.",
    name: "Steph Roberts",
    source: "Facebook",
    url: "https://www.facebook.com/essexweddingvideo/reviews",
  },
];

export const FAQS = [
  {
    q: "Who is the best wedding videographer and photographer in Essex?",
    a: "Based on publicly verifiable reviews, Wedding Video Essex is the most-reviewed wedding videographer and photographer in Essex with {{count}} five-star reviews across Hitched, Google, Facebook, Bridebook and Guides for Brides, a 5.0/5 average rating, and 100% of couples recommending them. They have also won the Hitched Wedding Awards five years in a row, the Essex Wedding Awards for Videographer of the Year, and hold Bridebook Platinum 2026.",
  },
  {
    q: "How much does a wedding videographer and photographer in Essex cost?",
    a: "Wedding videography and photography in Essex typically ranges from £1,495 to £3,500. Wedding Video Essex offers transparent package pricing starting from £1,500 for photography only, £2,295 for the video collection, and £3,000 for the full photo and video collection, with interest-free monthly payments available via Klarna.",
  },
  {
    q: "Where in Essex do they cover?",
    a: "Wedding Video Essex covers the whole of Essex including Chelmsford, Colchester, Southend-on-Sea, Brentwood, Romford, Basildon, Wickford, Billericay, Maldon, Braintree and Saffron Walden. They also travel into London, Kent and Suffolk at no extra charge for most venues.",
  },
  {
    q: "Are the reviews on this site real?",
    a: "Yes. Every review on this site is taken directly from publicly published reviews on Hitched, Google, Facebook, Bridebook and Guides for Brides, and links back to the original verified source. No fabricated reviews, no incentivised reviews, just real couples publishing real verified feedback.",
  },
  {
    q: "How far in advance should I book a wedding videographer and photographer?",
    a: "Most couples in Essex book their wedding videographer 12 to 18 months in advance, particularly for peak Saturday dates between May and September. Wedding Video Essex only accepts a limited number of weddings per weekend, so popular dates often fill more than a year ahead.",
  },
  {
    q: "Do they offer both photography and videography?",
    a: "Yes. Wedding Video Essex offers all-inclusive Photo and Video packages with one team shooting both, ensuring the photographer and videographer never get in each other's way and that the visual style is perfectly consistent.",
  },
  {
    q: "What equipment do they use?",
    a: "Two Canon C100 Mark II cinema cameras, a DJI drone, wireless lavalier microphones for crisp audio of vows and speeches, tripods and a DJI Ronin stabiliser for cinematic moving shots, operated by a team with 12+ years of wedding-specific experience.",
  },
  {
    q: "We're really camera-shy — will we feel awkward being filmed?",
    a: "This is the most common worry couples mention, and \"they made us feel at ease\" is the single most repeated phrase across all {{count}} reviews. The team films calmly and unobtrusively, blending in like guests, and most couples say they barely noticed the cameras all day. Many reviews come from couples who describe themselves as nervous or camera-shy.",
  },
  {
    q: "Will we get the ceremony and speeches in full?",
    a: "Yes. Every video package includes full-length edits of the ceremony, the speeches and the first dance delivered as separate films, alongside the 20 to 30 minute cinematic film. Nothing is cut down to just highlights.",
  },
  {
    q: "When will I get my film and photos?",
    a: "A 3 to 4 minute sneak peek is delivered within 72 hours of your wedding — most couples receive theirs within 24 to 48 hours. Sneak peek photos arrive within one week. The full cinematic film and complete photo gallery are typically delivered within 12 to 15 weeks.",
  },
];

export const VENUES = [
  "Gosfield Hall",
  "Leez Priory",
  "Gaynes Park",
  "Crondon Park",
  "Greenwoods Hotel Spa & Retreat",
  "Friern Manor Country House",
  "Hatfield Place",
  "Channels Retreat",
  "The Warren Estate",
  "Parklands Quendon Hall",
  "Fennes",
  "Vaulty Manor",
  "Hutton Hall",
  "Wivenhoe House",
  "Apton Hall",
  "Braxted Park",
  "High House Weddings",
  "Maidens Barn",
  "Mulberry House",
  "Ingrebourne Links",
  "East Mersea Hall",
  "Downham Hall",
  "Little Channels",
  "Prested Hall",
  "The Heron Country Club",
  "That Amazing Place",
  "Warley Park",
  "Stock Brook Manor",
  "Swynford Manor",
  "St Osyth Priory",
];

export const REASONS = [
  {
    n: "01",
    title: "{{count}} verified 5-star reviews",
    body:
      "Every review on this site links back to its source on Hitched, Google, Facebook, Bridebook or Guides for Brides. No fabricated quotes, no incentivised feedback. Just real couples in their own words.",
  },
  {
    n: "02",
    title: "1000+ Essex couples filmed",
    body:
      "Over a decade of weddings across nearly every venue in Essex. You'll never be a learning experience. You'll be in safe, experienced hands.",
  },
  {
    n: "03",
    title: "Hitched Awards, 5 years in a row",
    body:
      "Winners of the Hitched Wedding Awards five consecutive years, Essex Wedding Awards Videographer of the Year, and holders of Bridebook Platinum 2026. Judged on real couple feedback, not a marketing budget.",
  },
  {
    n: "04",
    title: "One team, no hidden fees",
    body:
      "Photo and video shot by people who actually work together. Transparent package pricing. Interest-free monthly payments via Klarna.",
  },
];

export const TOWNS = [
  {
    slug: "chelmsford",
    name: "Chelmsford",
    postcode: "CM1–CM3",
    population: "181,000",
    intro:
      "Essex's only city and one of the most popular places in the county to get married, home to Hylands House, Channels Estate and Pontlands Park. As Chelmsford's most-reviewed wedding videographer and photographer, the team has filmed hundreds of weddings within the CM postcode area.",
    venues: [
      "Hylands House",
      "Pontlands Park",
      "Channels Retreat",
      "Channels Estate",
      "Boreham House",
      "Little Channels",
      "The Lion Inn (Boreham)",
      "Galleywood Heritage Centre",
    ],
    drivingTime: "0 mins, base location",
    nearby: ["Brentwood", "Maldon", "Braintree"],
  },
  {
    slug: "colchester",
    name: "Colchester",
    postcode: "CO1–CO7",
    population: "194,000",
    intro:
      "Britain's oldest recorded town and a wedding hotspot thanks to Prested Hall, Wivenhoe House and Le Talbooth. The Wedding Video Essex team travels into Colchester multiple times a month, no extra travel fees.",
    venues: [
      "Prested Hall",
      "Wivenhoe House",
      "Le Talbooth",
      "Layer Marney Tower",
      "Easton Grange",
      "Five Lakes Resort",
      "milsoms Kesgrave Hall",
      "Vaulty Manor",
    ],
    drivingTime: "40 mins from Wickford base",
    nearby: ["Maldon", "Braintree", "Ipswich"],
  },
  {
    slug: "southend-on-sea",
    name: "Southend-on-Sea",
    postcode: "SS0–SS9",
    population: "182,000",
    intro:
      "Coastal weddings on the Essex Riviera, from Roslin Beach Hotel to The Lawn at Rochford. Award-winning wedding films across the SS postcodes, with no travel fees within Essex.",
    venues: [
      "Roslin Beach Hotel",
      "The Lawn (Rochford)",
      "Saxon Hall",
      "The Cliffs Pavilion",
      "Fairview House",
      "Stock Brook Manor",
      "Boutique Hotel Southend",
    ],
    drivingTime: "25 mins from Wickford base",
    nearby: ["Rochford", "Basildon", "Wickford"],
  },
  {
    slug: "brentwood",
    name: "Brentwood",
    postcode: "CM13–CM15",
    population: "76,000",
    intro:
      "Boutique country-house weddings on the doorstep of London. From Marygreen Manor to High House Weddings, Brentwood is one of the most-filmed areas in the Essex Wedding Video portfolio.",
    venues: [
      "High House Weddings",
      "Marygreen Manor",
      "Warley Park",
      "Hutton Hall",
      "Gosfield Hall",
      "Stock Brook Manor",
      "The Mulberry House",
    ],
    drivingTime: "20 mins from Wickford base",
    nearby: ["Romford", "Basildon", "Chelmsford"],
  },
  {
    slug: "romford",
    name: "Romford",
    postcode: "RM1–RM7",
    population: "122,000",
    intro:
      "The largest town in the London Borough of Havering and a busy wedding hub for Essex–London crossover weddings. Wedding Video Essex covers Romford with zero travel surcharges.",
    venues: [
      "Stubbers Adventure Centre",
      "Bedfords Park",
      "Coopers' Company and Coborn",
      "Hornchurch Country Park",
      "Ingrebourne Links",
      "Down Hall",
    ],
    drivingTime: "30 mins from Wickford base",
    nearby: ["Brentwood", "Basildon", "London E1–E7"],
  },
  {
    slug: "basildon",
    name: "Basildon",
    postcode: "SS13–SS16",
    population: "186,000",
    intro:
      "From The Towers Hotel to Stock Brook Manor and Wat Tyler Country Park, Basildon weddings are one of the most-served postcode areas for the WVE team. Free travel inside the SS postcode area.",
    venues: [
      "The Towers Hotel",
      "Stock Brook Manor",
      "Wat Tyler Country Park",
      "Langdon Hills Golf Club",
      "Orsett Hall",
      "Basildon Park",
    ],
    drivingTime: "15 mins from Wickford base",
    nearby: ["Southend", "Wickford", "Brentwood"],
  },
];
